import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Breadcrumb from "sushiweb/Breadcrumb";
import { FlexContainer, Heading } from "../../../constants/assets/containers";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useHistory, useParams } from "react-router-dom";
import { getPath } from "../../../utils/index";
import * as DriverStoriesActions from "../../../store/actions/DriverStories";
import StoryInfo from "../../../components/DriverStories/StoryInfo";
import Dropdown from "sushiweb/Dropdown";
import MenuItem from "sushiweb/MenuItem/MenuItem";
import Back from "sushiweb/Icons/all/Back";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import Permission from "../../../components/Common/Permission";
import variables from "../../../constants/assets/variables";

const StoriesCampaignDetails = ({
  activeCampaignDetails,
  getActiveCampaign,
  deactivateStory,
}) => {
  const { id } = useParams();
  const history = useHistory();
  const allActions = MenuActionsMappings[MenuNames.DRIVER_STORIES];

  const handleBackClick = () => {
    history.push(`/stories`);
  };

  useEffect(() => {
    getActiveCampaign(id);
  }, [id]);

  return (
    <div className="container">
      <Heading>&emsp;Details</Heading>
      <FlexContainer align="flex-start">
        <div>
          <FlexContainer>
            &emsp;&emsp;
            <Back
              onClick={handleBackClick}
              className="mr-10 backBtn"
              color={variables.grey400}
            />
            <Breadcrumb className="sushi-breadcrumbs">
              <Breadcrumb.Link linkTo="/stories">All Stories</Breadcrumb.Link>
              <Breadcrumb.Link>View story details</Breadcrumb.Link>
            </Breadcrumb>
          </FlexContainer>
        </div>
      </FlexContainer>
      <StoryInfo
        activeCampaignDetails={activeCampaignDetails}
        activeCampaignId={id}
        deactivateStory={deactivateStory}
      />
    </div>
  );
};

const LanguageDropdown = styled.div`
  flex: 0 1 50%;
  .sushi-dropdown {
    width: 50%;
  }
`;

function mapStateToProps(state) {
  const { DriverStories } = state;
  return {
    activeCampaignDetails: DriverStories.activeCampaignDetails,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getActiveCampaign: bindActionCreators(
      DriverStoriesActions.getActiveCampaign,
      dispatch
    ),
    resetState: bindActionCreators(DriverStoriesActions.resetState, dispatch),
    deactivateStory: bindActionCreators(
      DriverStoriesActions.deactivateStory,
      dispatch
    ),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StoriesCampaignDetails);
